"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var anymatch_1 = __importDefault(require("anymatch"));
var Middleware_helpers_1 = require("../Middleware.helpers");
var authorizationMiddleware = function (authConfig) { return function (api) { return function (next) { return function (action) {
    var isRouterAction = Middleware_helpers_1.contains(authConfig.actions, action.type);
    if (isRouterAction) {
        var isAuthenticated = authConfig.isAuthenticated();
        var pathname = action.payload.location.pathname;
        var isProtectedRoutes = anymatch_1.default(authConfig.protectedRoutes, pathname);
        if (isAuthenticated && !isProtectedRoutes) {
            api.dispatch(authConfig.successAction);
        }
        if (!isAuthenticated && isProtectedRoutes) {
            api.dispatch(authConfig.failAction);
        }
    }
    return next(action);
}; }; }; };
exports.default = authorizationMiddleware;
//# sourceMappingURL=AuthorizationMiddleware.js.map